export const hasPricingPage = ['rank-tracker', 'geogrid', 'local-audit'];

export type FeatureWithPricing = (typeof hasPricingPage)[number];

export const pricingPageConfig: Record<
  FeatureWithPricing,
  {
    title: string;
    description: string;
  }
> = {
  'rank-tracker': {
    title: 'Rank Tracker Pricing',
    description:
      'No usage markups. Bring your own DataForSEO key and unlock unlimited rank tracking.',
  },
  geogrid: {
    title: 'GeoGrid Pricing',
    description:
      'The most cost effective and accurate way to track the rank of any business listing.',
  },
  'local-audit': {
    title: 'Local Audit Pricing',
    description:
      'Comprehensive GBP audit reports to analyze and optimize your local business presence.',
  },
};
